import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

import { LayoutModule } from './views/layout/layout.module';
import { AuthGuard } from './core/guard/auth.guard';

import { AppComponent } from './app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFireFunctionsModule } from "@angular/fire/functions";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { environment } from "../environments/environment";
import { AngularFireMessagingModule } from "@angular/fire/messaging";
import { CurrencyPipe } from './shared/pipes/currency.pipe';
import { OrdersComponent } from './views/pages/orders/orders.component';
import { CategoriesComponent } from './views/pages/categories/categories.component';
import { GoBackBreadcrumbComponent } from './views/pages/go-back-breadcrumb/go-back-breadcrumb.component';
import { IonIntlTelInputModule } from "ion-intl-tel-input";
import { Workbook } from 'exceljs';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NotificationSendModalComponent } from './views/pages/notifications/notification-send-modal/notification-send-modal.component';

import { SettingsService } from './services/settings.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// Carga secuencial de settings antes de arrancar la app
export function initSettings(settings: SettingsService) {
  return () => new Promise<void>((resolve) => {
    settings.loadGeneralSettings().subscribe({
      next: () => {
        settings.loadSplashSettings().subscribe({
          next: () => {
            settings.loadShippingSettings().subscribe({
              next: () => {
                settings.loadInvoicingSettings().subscribe({
                  next: () => resolve(),
                  error: () => resolve()
                });
              },
              error: () => resolve()
            });
          },
          error: () => resolve()
        });
      },
      error: () => resolve()
    });
  });
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    CurrencyPipe,
    OrdersComponent,
    CategoriesComponent,
    GoBackBreadcrumbComponent,
    NotificationSendModalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    LayoutModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule.enablePersistence(),
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireMessagingModule,
    AngularFireFunctionsModule,
    IonIntlTelInputModule,
  ],
  providers: [
    AuthGuard,
    Workbook,
    {
      provide: APP_INITIALIZER,
      useFactory: initSettings,
      deps: [SettingsService],
      multi: true
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
        }
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}